type P = {
  opinionComment: string;
};

const OpinionComment = ({ opinionComment }: P) => {
  // HTML 태그 제거하고 텍스트만 추출
  const stripHTML = (html: string) => {
    const temp = document.createElement('div');
    temp.innerHTML = html;
    return temp.textContent || temp.innerText || '';
  };

  const cleanText = stripHTML(opinionComment);

  return (
    <div
      style={{
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: 'inline-block',
        maxWidth: '100%',
      }}
    >
      {cleanText}
    </div>
  );
};

export default OpinionComment;
